const LIST_TYPES = ['phx_number', 'phx_alpha', 'phx_bullet', 'check', 'legacy_number', 'legacy_alpha'] as const;
export type ListTypeUnion = typeof LIST_TYPES[number];

// Normalise external list type strings (data-list-type values, legacy names)
// into our internal Phx variants / keys used below.
const normalizeListType = (type: string): ListTypeUnion | null => {
  switch (type) {
    case 'number':
    case 'phx_number':
      return 'phx_number';
    case 'alpha':
    case 'phx_alpha':
      return 'phx_alpha';
    case 'bullet':
    case 'phx_bullet':
      return 'phx_bullet';
    case 'legacy_number':
      return 'legacy_number';
    case 'legacy_alpha':
      return 'legacy_alpha';
    case 'check':
      return 'check';
    default:
      return null;
  }
};

export const listStyles: Record<ListTypeUnion, string[]> = {
  phx_bullet: ['square', 'circle'],
  phx_number: ['decimal', 'lower-alpha', 'lower-roman'],
  phx_alpha: ['upper-alpha', 'lower-alpha', 'lower-roman'],
  legacy_number: ['decimal', 'lower-alpha'],
  legacy_alpha: ['lower-alpha', 'decimal'],
  check: ['none'],
};

export const listTypeToStyle: Record<ListTypeUnion, string> = {
  phx_number: 'decimal',
  phx_alpha: 'lower-alpha',
  phx_bullet: 'disc',
  check: 'none',
  legacy_number: 'decimal',
  legacy_alpha: 'lower-alpha',
};

export const isValidListType = (type: string): type is ListTypeUnion => {
  const normalized = normalizeListType(type);
  return normalized != null && LIST_TYPES.includes(normalized);
};

export const getListMarker = (type: string, level: number): string => {
  const normalized = normalizeListType(type);
  const key: ListTypeUnion = normalized ?? 'phx_bullet';
  const markers = listStyles[key] || listStyles.phx_bullet;
  return markers[level % markers.length];
}; 